import { useMeContext } from '~/modules/me';

export const useIsColumnarTotalsEnabled = () => {
  const {
    featureFlags: {
      isPsaRmpResourcePlanColumnarTotalsEnabled,
      isPsaRmpTaskAllocation1Enabled
    }
  } = useMeContext();

  return Boolean(
    isPsaRmpResourcePlanColumnarTotalsEnabled && isPsaRmpTaskAllocation1Enabled
  );
};

export default useIsColumnarTotalsEnabled;
